/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import {SignalAdminResourceEditPageBase} from '../../common/controller/signal-admin-resource-edit-page-base';
import {NOTES_BUTTONS} from '../../common/directives/notes/notes-constants';
import template from './release-notes-edit-page.component.html';
import {ReleaseNoteModel, ReleaseNotesApiService} from './release-notes-api.service';

@Component({
  standalone: false,
  selector: 'adn-release-notes-edit-page',
  template
})
export class ReleaseNotesEditPageComponent extends SignalAdminResourceEditPageBase<ReleaseNoteModel> {
  readonly toolbarButtons = NOTES_BUTTONS;
  readonly apps = ['MARKETPLACE', 'ADSERVER', 'DATA'];
  readonly tags = ['FEATURE', 'BUGFIX', 'INFO', 'UPDATE'];

  publishMode = 'IMMEDIATE';
  visibility = 'PUBLIC';

  constructor(releaseNotesApi: ReleaseNotesApiService) {
    super(releaseNotesApi, 'releaseNote');
  }

  onAssetStringsChange(assetStrings: string[]): void {
    this.editingModel.assetStrings = assetStrings;
    this.markExternalFormDirty();
  }

  toggleArrayValue(values: string[], value: string): void {
    const index = values.indexOf(value);
    if (index >= 0) {
      values.splice(index, 1);
    } else {
      values.push(value);
    }
    this.markExternalFormDirty();
  }

  onPublishModeChange(): void {
    if (this.publishMode === 'IMMEDIATE') {
      this.editingModel.publishTime = null;
    }
  }

  protected override afterEditingModelReset(): void {
    this.editingModel.apps = this.editingModel.apps || [];
    this.editingModel.tags = this.editingModel.tags || [];
    this.editingModel.userGroups = this.editingModel.userGroups || [];
    this.editingModel.assetStrings = this.editingModel.assetStrings || [];
    this.publishMode = this.editingModel.publishTime ? 'CUSTOM' : 'IMMEDIATE';
    this.visibility = this.editingModel.userGroups.length ? 'INTERNAL' : 'PUBLIC';
  }

  protected override prepareForSubmit(model: ReleaseNoteModel): void {
    if (this.publishMode === 'IMMEDIATE') {
      model.publishTime = null;
    }
    model.userGroups = this.visibility === 'INTERNAL' ? ['INTERNAL'] : [];
  }
}
